import NavigatorСode from "./NavigatorСodeApp";

export const tasks = [
  {
    type: 1,
    id: "1",
    rounds: [
      {
        table: [
          ["Е", "Т", "И", "Е", "П", "К"],
          ["Ш", "Е", "Н", "А", "Л", "И"],
          ["У", "Р", "О", "Р", "О", "К"],
          ["А", "К", "Й", "А", "Т", "О"],
          ["Н", "Е", "Л", "Б", "В", "З"],
          ["Т", "Ы", "Д", "З", "Е", "У"],
        ],
        words: "Кораблекрушение на второй планете от звезды",
        
      },
      {
        table: [
          ["К", "С", "Т", "Е", "Й"],
          ["Г", "О", "С", "А", "В"],
          ["Н", "Е", "У", "Т", "С"],
          ["Ы", "Л", "И", "Р", "И"],
          ["М", "А", "Ч", "Е", "С"],
        ],
        words: "Гостей с Сириуса мы не встречали",
      },
    ],
  },

  // Второй тип игры
  {
    type: 2,
    id: "1",
    rounds: [
      {
        table: [
          ["Е", "Т", "И", "Е", "П", "К"],
          ["Ш", "Е", "Н", "А", "Л", "И"],
          ["У", "Р", "О", "Р", "О", "К"],
          ["А", "К", "Й", "А", "Т", "О"],
          ["Н", "Е", "Л", "Б", "В", "З"],
          ["Т", "Ы", "Д", "З", "Е", "У"],
        ],
        words: "Кораблекрушение на планете звезды",
        
      },
      {
        table: [
          ["К", "С", "Т", "Е", "Й"],
          ["Г", "О", "С", "А", "В"],
          ["Н", "Е", "У", "Т", "С"],
          ["Ы", "Л", "И", "Р", "И"],
          ["М", "А", "Ч", "Е", "С"],
        ],
        words: "Гостей с сириуса мы не встречали",
      },
      
    ],
  },
];

const navigatorСodeRoutes = tasks.flatMap((task) => [
  {
    path: `/Navigator/${task.type}/${task.id}`,
    element: (
      <NavigatorСode random={false} rounds={task.rounds} type={task.type} />
    ),
  },
  {
    path: `/Navigator/${task.type}/${task.id}/r`,
    element: (
      <NavigatorСode random={true} rounds={task.rounds} type={task.type} />
    ),
  },
]);
export default navigatorСodeRoutes;
